import { proxy, useSnapshot } from 'valtio';
import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';

interface DebugModeState {
  enabled: boolean;
}

const LOCAL_STORAGE_KEY = 'ccpDebugMode';
const storedState = window.localStorage.getItem(LOCAL_STORAGE_KEY);
const initialState = storedState
  ? (JSON.parse(storedState) as DebugModeState)
  : {
      enabled: false,
    };

const state = proxy<DebugModeState>(initialState);

export class DebugModule extends AppModule {
  public setDebugMode(enabled: boolean) {
    state.enabled = enabled;
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state));
  }

  public isDebugModeEnabled(): boolean {
    return state.enabled;
  }
}

export function useDebugMode(): DebugModeState {
  return useSnapshot(state);
}

/**
 * Allow toggling debug mode from the dev console.
 *
 * When deep in a sidebar, opening the debug panel means losing your state.
 *
 * By making this globally available, we let devs avoid that.
 */
window.toggleCcpDebugMode = () => {
  module.setDebugMode(!state.enabled);
};

declare global {
  interface Window {
    toggleCcpDebugMode?(): void;
  }
}

const module = new DebugModule(appManager.events, appManager.logger('Debug'));

export default module;
